import { render, staticRenderFns } from "./EditDispatchOrder.vue?vue&type=template&id=77021ab7&scoped=true"
import script from "./EditDispatchOrder.vue?vue&type=script&lang=js"
export * from "./EditDispatchOrder.vue?vue&type=script&lang=js"
import style0 from "./EditDispatchOrder.vue?vue&type=style&index=0&id=77021ab7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77021ab7",
  null
  
)

export default component.exports